import { cn } from "@/lib/utils";

interface PageHeaderProps {
  className?: string;
  heading: string;
  subheader?: string;
  text?: string;
}

export function PageHeader({
  className,
  heading,
  subheader,
  text,
}: PageHeaderProps) {
  return (
    <div className={cn("flex flex-col items-center space-y-2", className)}>
      <h1 className="text-3xl font-black tracking-tight lg:text-4xl">
        {heading}
      </h1>
      {subheader && (
        <h4 className="text-center text-lg tracking-tight xl:text-xl">
          {subheader}
        </h4>
      )}
      {text && <p className="text-md text-center tracking-tight">{text}</p>}
    </div>
  );
}
